/** Parse YYYY-MM-DD or ISO without shifting the intended calendar day */
export function parseCalendarDateInput(input: string | Date): Date {
  if (input instanceof Date) return input;
  const s = input.trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(y!, m! - 1, d!);
  }
  return new Date(s);
}

export function parseUtcFromApi(dateString: string): Date {
  if (!dateString) return new Date(NaN);
  const s = dateString.trim();
  if (s.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const [y, m, d] = s.split('-').map(Number);
    return new Date(Date.UTC(y!, m! - 1, d!));
  }
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(s)) {
    return new Date(s.replace(' ', 'T') + 'Z');
  }
  return new Date(s.includes('T') ? (s.endsWith('Z') ? s : `${s}Z`) : `${s}Z`);
}

export function toUtcIsoInstantForApi(): string {
  return new Date().toISOString();
}

export function localCalendarDateToUtcDateString(date: Date): string {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    .toISOString()
    .split('T')[0]!;
}

export function toUtcDateOnlyForApi(input: string | Date): string {
  return localCalendarDateToUtcDateString(parseCalendarDateInput(input));
}

export function localMonthRangeToUtcDateStrings(yyyyMm: string): {
  dateFrom: string;
  dateTo: string;
} {
  const [y, m] = yyyyMm.split('-').map(Number);
  const lastDay = new Date(y!, m!, 0).getDate();
  return {
    dateFrom: localCalendarDateToUtcDateString(new Date(y!, m! - 1, 1)),
    dateTo: localCalendarDateToUtcDateString(new Date(y!, m! - 1, lastDay)),
  };
}

export function formatBillingDateOnly(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = parseUtcFromApi(iso.split('T')[0]!);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatBillingDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = parseUtcFromApi(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return (
    d.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }) +
    ' ' +
    d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })
  );
}
